export * from '../pessoa/pessoa.service';
export * from '../pessoa/pessoa.component';
export * from '../pessoa/tab/tab.component';

